import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';

@Injectable({
  providedIn: 'root'
})
export class RebateContractService {

  constructor(private http: HttpClient) { }

  syncStatus(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/sync-status', params);
  }


  getAnnualList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/annual-contract-target-completion/list', params);
  }
  getQuarterlyList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/quarterly-contract-target-completion/list', params);
  }
  getRebateYearList(params: any) {
    return this.http.get<RequestModel>(
      '/dealer_portal/target-ach/rebate-detail-overview',
      {
        params
      },
    );
  }
  getYearList(params: any) {
    return this.http.get<RequestModel>(
      '/dealer_portal/target-ach/rebate-overview',
      {
        params
      },
    );
  }
  getProductlineList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/productline-contract-target-completion/list', params);
  }
  getAdditionallineList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/additional-rebate-completion/list', params);
  }
  getMarketList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/market-rebate-completion/list', params);
  }
  getSettledList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/settled-rebate-detail/list', params);
  }

  getReleasedList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/distributed-rebate-detail/list', params);
  }

  getUsedList(params: any) {
    return this.http.post<any>('/dealer_portal/target-ach/used-rebate-detail/list',params);
  }

  
}
